'use strict';

const ajax = require('./modules/ajax');
const scrollHelper = require('./modules/helpers/scroll');
const damHelper = require('./dam/dam-helper');

function initEvents(){
    // close flyouts when clicking the modal overlay or the flyout close button
    $(document).on('click touchstart', '.js-modal-overlay, .js-close-toaster', function(){
        closeToasters();
    });

    $('.js-close-toaster').on('keyup', function(e){
        if (e.which == 13) {
            // on enter close the flyout
            closeToasters();
        }
    });
}

/**
 * @function
 * @description General open flyout function
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function open(params){
    if (params.target) {
        $(params.target).show();

        // add timeout to preserve css animation
        setTimeout(function() {
            $(params.target).addClass('open');

            // show modal overlay
            toaster.def.$modalOverlay.fadeIn();

            damHelper.updateImages($(params.target));
        }, 600);

    } else {
        toaster.def.$genericToast.show();

        setTimeout(function() {
            toaster.def.$genericToast.addClass('open');

            if ($('.gwp-popup-padding').length > 0) {
                $('.gwp-popup-padding').each(function(){
                    $(this).closest('.generic-toaster-container').addClass('no-padding');
                });
            }

            // show modal overlay
            toaster.def.$modalOverlay.fadeIn();

            damHelper.updateImages(toaster.def.$genericToast);
        }, 600);
    }

    if (params.open && typeof params.open == 'function') {
        params.open();
    }

    // lock body scroll
    scrollHelper.disableScroll();

    if (params.close) {
        toaster.def.$genericToast.off('toaster:close');
        toaster.def.$genericToast.on('toaster:close', function () {
            params.close();
        });
    }
}

/**
 * @function
 * @description Loads flyout content through ajax and then opens and inits it
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function load(options){
    ajax.load({
        url: options.url,
        target: $('.js-generic-toaster > .js-toaster-content'),
        callback: function () {
            initEvents();
            const params = {};

            if (options.close){
                params.close = options.close;
            }

            open(params);
            if (options.open) {
                options.open();
            }
        }
    });
}

/**
 * @function
 * @description Close all flyouts and overlay
 */
function closeToasters(target){
    // if there's a specific target, use that. Otherwise close all toasters
    const $toasterEl = target ? $(target) : toaster.def.$toasterGeneralEl;

    // close all flyouts
    $toasterEl.removeClass('open');

    // hide modal overlay
    toaster.def.$modalOverlay.fadeOut(1000, function(){
        $toasterEl.hide();
        scrollHelper.enableScroll();
        $toasterEl.trigger('toaster:close');
    });
}

function initDef() {
    toaster.def.$toasterGeneralEl = $('.js-toaster-container');
    toaster.def.$modalOverlay = $('.js-modal-overlay');
    toaster.def.$genericToast = $('.js-generic-toaster');
    toaster.def.$toastContent = $('.js-toaster-content');
}

const toaster = {
    def: {
        $toasterGeneralEl: $('.js-toaster-container'),
        $modalOverlay: $('.js-modal-overlay'),
        $genericToast: $('.js-generic-toaster'),
        $toastContent: $('.js-toaster-content')
    },
    init: function () {
        initEvents();
    },
    initDef: initDef,
    open: open,
    load: load,
    closeToasters: closeToasters
};

module.exports = toaster;
